import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        destinations: false
      },
      options: {
        destinations: []
      },
      selected: {
        destination: '',
        allowOut: 1,
        allowIn: 1,
        locationType: 'Branch'
      },
      editable: {
        destination: ''
      }
    }
  },

  methods: {

    async getDestinations (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.destination
      const allowIn = context.selected?.allowIn
      const allowOut = context.selected?.allowOut
      const fetching = context.fetching?.destinations
      const options = context.options?.destinations

      const hasInvalidContext = [
        selected,
        allowIn,
        allowOut,
        fetching,
        options
      ].some(nullOrUndefined)

      if (hasInvalidContext) {
        throw Error('Invalid context object')
      }

      context.fetching.destinations = true
      context.selected.destination = ''

      const filters = {
        filter_text: search,
        allow_in: context.selected.allowIn,
        allow_out: context.selected.allowOut,
        location_type: context.selected.locationType
      }

      return await SSharedList.getLocations(filters).then(
        ({ data }) => {
          context.options.destinations = data.filter(
            destination => String(destination.id) !== String(this.user?.location)
          )
        }
      ).catch(() => {
        context.options.destinations = []
      }).finally(() => {
        context.fetching.destinations = false
      })
    },

    async searchDestinations (search, loading) {
      this.searchDestinationsProvider(this, search, loading)
    },

    searchDestinationsProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.destinations, {
          keys: ['location_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            allow_in: selected.allowIn,
            allow_out: selected.allowOut,
            location_type: selected.locationType
          }

          SSharedList.getLocations(filters).then(
            ({ data }) => {
              options.destinations = data
            }
          ).catch(() => {
            options.destinations = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
